import Capaian from 'Layout/Capaian';
import CounterPage from 'Layout/CounterPage';
import DocumentPage from 'Layout/DocumentPage';
import MenuGampong from 'Layout/MenuGampong';
import News from 'Layout/News';
import Sambutan from 'Layout/Sambutan';
import Header from '../components/Header';
import Layout from '../Layout';

export default function HomePage() {

  return (
    <Layout active="home">
      <Header />
      <MenuGampong />
      <Sambutan />
      <CounterPage />
      <Capaian />
      <DocumentPage/>
      <News/>
    </Layout>
  );
}
